import React from 'react'
import { Button, Box } from '@shopify/polaris'
import CardImg from 'img/icons/misc/card.svg'
import EditIconButton from './EditIconButton'

const BalanceDisplay = ({ balanceAmount, currencySymbol, t, isManager, onEditClick }) => {
	return (
		<div style={{ display: 'flex', alignItems: 'center' }}>
			<div style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				width: '100%',
				flexWrap: 'wrap',
				gap: '10px'
			}}>
				<div style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-start',
					flex: '1',
					minWidth: '200px'
				}}>
					<img
						src={CardImg}
						alt='card'
						style={{
							maxHeight: '50px',
							maxWidth: '50px',
							width: '100%',
							height: '100%'
						}}
					/>
					<Box padding='4' maxWidth='500px'>
						<h2 style={{
							fontSize: '16px',
							fontWeight: 600,
							lineHeight: 1.2
						}}>
							{t("home.balance")} ({t("home.deposit")})
						</h2>
						<span style={{
							fontSize: '18px',
							fontWeight: 400,
							lineHeight: 1.2
						}}>
							{balanceAmount}{currencySymbol ?? ' \u{20AC} '}
						</span>
					</Box>
				</div>

				<div style={{
					display: 'flex',
					alignItems: 'center',
					gap: '10px',
					flexShrink: 0
				}}>
					{isManager && <EditIconButton onClick={onEditClick} />}
					<Button variant={'primary'} size={'micro'} disabled>
						{t("home.addDeposit")}
					</Button>
				</div>
			</div>
		</div>
	)
}

export default BalanceDisplay

